<div class="modal-header">
  <h3 class="modal-title">Notification rules setup</h3>
  <button
    type="button"
    class="close"
    (click)="close()"
    aria-label="Close"
    tabindex="1">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <div class="form-group row">
    <div class="col-sm-12">
      <app-notifications-setup-work-items></app-notifications-setup-work-items>
    </div>
  </div>
</div>

<div class="modal-footer justify-content-between">
  <button
    type="button"
    class="btn btn-secondary btn-sm"
    (click)="close()"
    tabindex="3">
    Cancel
  </button>
  <div>
    <button
      type="button"
      class="btn btn-primary btn-sm"
      (click)="save()"
      tabindex="4">
      Done
    </button>
  </div>
</div>
